import React from "react";
import { FormField } from "../../../types/formTypes";
import TextFieldPreview from "./TextFieldPreview";
import TextareaFieldPreview from "./TextareaFieldPreview";
import SelectFieldPreview from "./SelectFieldPreview";
import RadioFieldPreview from "./RadioFieldPreview";
import CheckboxFieldPreview from "./CheckboxFieldPreview";
import ChipsFieldPreview from "./ChipsFieldPreview";
import DateFieldPreview from "./DateFieldPreview";
import TimeFieldPreview from "./TimeFieldPreview";
import FileFieldPreview from "./FileFieldPreview";
import OdontogramFieldPreview from "./OdontogramFieldPreview";
import AppointmentFieldPreview from "./AppointmentFieldPreview";

interface FieldPreviewProps {
	field: FormField;
	onUpdateOptions?: (options: string[]) => void;
	onUpdateField?: (updates: Partial<FormField>) => void;
}

const FieldPreview: React.FC<FieldPreviewProps> = ({
	field,
	onUpdateOptions,
	onUpdateField,
}) => {
	// Helper to render description if available
	const renderDescription = () => {
		if (field.description) {
			return (
				<p className="text-sm text-gray-500 mb-2">
					{field.description}
				</p>
			);
		}
		return null;
	};

	// Delegate to the appropriate field type component
	switch (field.type) {
		case "text":
			return (
				<TextFieldPreview
					field={field}
					renderDescription={renderDescription}
				/>
			);

		case "textarea":
			return (
				<TextareaFieldPreview
					field={field}
					renderDescription={renderDescription}
				/>
			);

		case "select":
			return (
				<SelectFieldPreview
					field={field}
					renderDescription={renderDescription}
					onUpdateOptions={onUpdateOptions}
				/>
			);

		case "radio":
			return (
				<RadioFieldPreview
					field={field}
					renderDescription={renderDescription}
					onUpdateOptions={onUpdateOptions}
					onUpdateField={onUpdateField}
				/>
			);

		case "chips":
			return (
				<ChipsFieldPreview
					field={field}
					renderDescription={renderDescription}
					onUpdateOptions={onUpdateOptions}
					onUpdateField={onUpdateField}
				/>
			);

		case "checkbox":
			return (
				<CheckboxFieldPreview
					field={field}
					renderDescription={renderDescription}
					onUpdateOptions={onUpdateOptions}
				/>
			);

		case "date":
			return (
				<DateFieldPreview
					field={field}
					renderDescription={renderDescription}
				/>
			);

		case "time":
			return (
				<TimeFieldPreview
					field={field}
					renderDescription={renderDescription}
				/>
			);

		case "file":
			return (
				<FileFieldPreview
					field={field}
					renderDescription={renderDescription}
				/>
			);

		case "odontogram":
			return (
				<OdontogramFieldPreview
					field={field}
					renderDescription={renderDescription}
					onUpdateOptions={onUpdateOptions}
				/>
			);

		case "appointment":
			return (
				<AppointmentFieldPreview
					field={field}
					renderDescription={renderDescription}
					onUpdateOptions={onUpdateOptions}
				/>
			);

		default:
			return null;
	}
};

export default FieldPreview;
